module.exports = __webpack_public_path__ + "media/images/favicon/favicon-160-b83e423598c5b5c7b51f172e9fb91c9e.png";